import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import DropzoneComponent from 'react-dropzone-component';
import withStyles from 'isomorphic-style-loader/withStyles';
import { connect } from 'react-redux';
import cx from 'classnames';

import { doUploadProfilePicture, doRemoveProfilePicture } from '../../actions/manageUserProfilePicture';
import { setLoaderComplete, setLoaderStart } from '../../actions/loader/loader';
import showToaster from '../../helpers/showToaster';
import { demoRestriction, userRestriction } from '../../helpers/DemoRestriction/demoRestriction';

import EditIconSvg from '/public/SiteIcons/profileEditIcon.svg';
import { EditIcon } from '../Common/Assets/SvgComponent/commonSvgIcon';

import s from 'react-dropzone-component/styles/filepicker.css';
import cs from '../../styles/profileDropzone.css';

class Dropzone extends Component {

    static propTypes = {
        doUploadProfilePicture: PropTypes.any.isRequired,
        doRemoveProfilePicture: PropTypes.any.isRequired,
    };

    constructor(props) {
        super(props);
        this.success = this.success.bind(this);
        this.addedfile = this.addedfile.bind(this);
        this.dropzone = null;
    }

    componentDidUpdate() {
        const isBrowser = typeof window !== 'undefined';
        const isDocument = typeof document !== undefined;
        if (isBrowser && isDocument) {
            document.querySelector(".dz-hidden-input").style.visibility = 'visible';
            document.querySelector(".dz-hidden-input").style.opacity = '0';
            document.querySelector(".dz-hidden-input").style.height = '100%';
            document.querySelector(".dz-hidden-input").style.width = '100%';
            document.querySelector(".dz-hidden-input").style.cursor = 'pointer';
        }
    }

    async success(file, fromServer) {
        const { setLoaderStart, setLoaderComplete, isAdmin, demoRestriction, profileId, userRestriction } = this.props;
        const { doUploadProfilePicture, data } = this.props;
        let fileName = fromServer.file.filename;
        let oldPicture = data != undefined ? data.picture : null;
        const isRestrict = await userRestriction({ restrictType: 'profile', restrictValue: profileId });
        if (isAdmin) {
            const isCheckRestrict = await demoRestriction({});
            if (isCheckRestrict) {
                this.dropzone.removeFile(file);
                return;
            }
        } else if (isRestrict) {
            showToaster({ messageId: 'demoWarning', toasterType: 'warning' });
            this.dropzone.removeFile(file);
            return;

        }
        await setLoaderStart('profilePhotoLoader');
        await doUploadProfilePicture(fileName, oldPicture, data?.userId);
        await setLoaderComplete('profilePhotoLoader');
    }

    async addedfile(file) {
        const { maxUploadSize, setLoaderStart, setLoaderComplete, demoRestriction, profileId, isAdmin, userRestriction } = this.props;
        let isOnline = typeof window !== 'undefined' && window.navigator.onLine;
        const isRestrict = await userRestriction({ restrictType: 'profile', restrictValue: profileId });
        if (isAdmin) {
            const isCheckRestrict = await demoRestriction({});
            if (isCheckRestrict) {
                this.dropzone.removeFile(file);
                return;
            }
        } else if (isRestrict) {
            showToaster({ messageId: 'demoWarning', toasterType: 'warning' });
            this.dropzone.removeFile(file);
            return;
        }
        if (!isOnline) {
            showToaster({ messageId: 'offlineError', toasterType: 'error' })
            this.dropzone.removeFile(file);
            setLoaderComplete('profilePhotoLoader');
            return;
        }

        setLoaderStart('profilePhotoLoader')
        let filetypes = ['image/jpeg', 'image/png', 'image/jpg']
        if (file.size > (1024 * 1024 * parseInt(maxUploadSize))) {
            this.dropzone.removeFile(file);
            showToaster({ messageId: 'limitError', toasterType: 'error' })
            setLoaderComplete('profilePhotoLoader');
        }

        if (!filetypes.includes(file.type)) {
            showToaster({ messageId: 'fileTypeError', toasterType: 'error' })
            this.dropzone.removeFile(file);
            setLoaderComplete('profilePhotoLoader');
        }

    }


    render() {
        const { defaultMessage, isEditIcon, maxUploadSize } = this.props;
        const djsConfig = {
            dictDefaultMessage: '',
            addRemoveLinks: false,
            uploadMultiple: false,
            maxFilesize: maxUploadSize,
            acceptedFiles: 'image/jpeg,image/png',
            dictMaxFilesExceeded: 'Remove the existing image and try upload again',
            previewsContainer: false,
            hiddenInputContainer: '.dzInputContainer',
            maxFiles: 1,
            init: function () {
                this.on('addedfile', function (file) {
                    if (this.files.length > 1) {
                        this.removeFile(this.files[0]);
                    }
                });
            }
        };
        const componentConfig = {
            iconFiletypes: ['.jpg', '.png'],
            postUrl: '/uploadProfilePhoto'
        };
        const eventHandlers = {
            init: dz => this.dropzone = dz,
            success: this.success,
            addedfile: this.addedfile,
        };

        return (
            <div className={cx(!isEditIcon ? 'dashBoardImageUploadContainer' : 'dashBoardEditImageUploadContainer')}>
                <div className={cx('dzInputContainer', !isEditIcon ? 'profileDropzoneContainer' : 'editProfileDropZoneContainer')}>
                    <DropzoneComponent
                        config={componentConfig}
                        eventHandlers={eventHandlers}
                        djsConfig={djsConfig}
                    >
                        {
                            isEditIcon &&
                            <img src={EditIconSvg} className={'dropShadow'} />
                        }
                        {!isEditIcon && <EditIcon />
                        }
                        {defaultMessage && defaultMessage}
                    </DropzoneComponent>
                </div>
            </div>
        );
    }
}

const mapState = (state) => ({
    account: state.account.data,
    maxUploadSize: state?.siteSettings?.data?.maxUploadSize,
    profileId: state?.account?.data?.profileId,
});

const mapDispatch = {
    doUploadProfilePicture,
    doRemoveProfilePicture,
    setLoaderStart,
    setLoaderComplete,
    demoRestriction,
    userRestriction
};

export default injectIntl(withStyles(s, cs)(connect(mapState, mapDispatch)(Dropzone)));